import React from 'react';
import { motion } from 'framer-motion';
import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 2,
      ease: 'easeInOut',
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 2 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className="badge-cmp app__flex"
        >
          <span>👋</span>
          <div style={{ marginLeft: 5 }}>
            <p className="p-text" style={{ fontWeight: 'bolder' }}>
              😣Struggling To Create A SOFTWARE? : 👩‍💻Consult An Expert
            </p>
            <h1 className="head-text">VEDANT ‎</h1>
          </div>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className="tag-cmp app__flex"
        >
          <p className="p-text">
            <p>
              SOFTWARE ENGINEER · TECH ENTHUSIAST · AVIATION GEEK · ‎ CHESS IM
            </p>
          </p>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className="tag-cmp app__flex"
        >
          <p className="p-text">
            <p>
              ‎VFX & GFX · ADOBE AFTER EFFECTS · 3D MODEL · ADOBE PHOTOSHOP ‎{' '}
            </p>
          </p>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className="tag-cmp app__flex"
        >
          <p className="p-text">
            <p>
              {' '}
              ‎ GAME DEVELOPMENT · UNREAL ENGINE · UNITY · MAP DEVELOPMENT ‎{' '}
            </p>
          </p>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className="tag-cmp app__flex"
        >
          <p className="p-text">
            <p>
              ‎ETHICAL HACKING · SECURITY ENGINEER · SECURITY ARCHITECT · CEH ‎{' '}
            </p>
          </p>
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className="tag-cmp app__flex"
        >
          <p className="p-text">
            <p>
              {' '}
              ‎DESIGNER · USER INTERFACE/EXPIRIENCE · FIGMA · DEVICE RESPONSIVE
              ‎{' '}
            </p>
          </p>
        </motion.div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 2, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 2, ease: 'easeInOut' }}
        src={images.profile}
        alt="profile_above_circle"
        className="profile_on_circle"
      />

      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 2, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.skills_react, images.skills_python, images.skills_cpp].map(
        (circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="profile_bg" />
          </div>
        ),
      )}
    </motion.div>
    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles2"
    >
      {[images.skills_nextjs, images.skills_node, images.skills_flutter].map(
        (circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="profile_bg" />
          </div>
        ),
      )}
    </motion.div>
  </div>
);

export default AppWrap(Header, 'home');
